import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '../../fi-dialogs/fi-dialogs-content-base';

export interface IWarningConfirmDialogData {
    message: string;
    confirmText: string;
    warningMessage?: string;
}

@Component({
    selector: 'fi-warning-confirm-dialog',
    template: `
        <div class="dialog-heading-wrapper">
          <mat-icon class="fas fa-exclamation-circle"></mat-icon>
          <span>{{ 'common.warning' | fiAppText }}</span>
        </div>
        @if (data.warningMessage) {
          <p class="warning-message">{{ data.warningMessage }}</p>
        }
        <p>{{ data.message }}</p>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'common.type_here' | fiAppText }}</mat-label>
          <input type="text" matInput [(ngModel)]="confirmTextValue" />
        </mat-form-field>
        `,
    styleUrls: ['./fi-warning-confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-warning-confirm-dialog' },
    standalone: false,
})
export class FiWarningConfirmDialogComponent extends FiDialogsContentBase<IWarningConfirmDialogData, void> {
    confirmTextValue: string;

    isYesButtonDisabled(): boolean {
        return this.data.confirmText !== this.confirmTextValue;
    }
}
